// import React, { useState } from 'react'
// import { Menu, X, ShoppingCart, Search } from 'lucide-react'
// import { Link } from 'react-router-dom'
// import Logo from '../assets/logo.svg'

// const Navbar: React.FC = () => {
//   const [isOpen, setIsOpen] = useState(false)

//   return (
//     <nav className='sticky top-0 z-50 bg-white shadow-md'>
//       <div className='max-w-7xl mx-auto px-6'>
//         <div className='flex items-center justify-between h-20'>
//           {/* Logo */}
//           {/* <Link to="/" className="flex items-center gap-2">
//             <div className="w-10 h-10 bg-gradient-to-br from-[#F47C20] to-[#E83E6F] rounded-full">
//             </div>
//             <span className="text-xl font-bold text-[#C62828]">
//               Amera Exports
//             </span>
//           </Link> */}

//           <Link to='/' className='flex items-center gap-2'>
//             <div className='w-12 h-12 rounded-full bg-white flex items-center justify-center shadow-sm border border-black/5'>
//               <img
//                 src={Logo}
//                 alt='Amera Exports Logo'
//                 className='w-12 h-12 object-contain'
//                 draggable={false}
//               />
//             </div>

//             <span className='text-xl font-bold text-[#C62828]'>
//               Amera Exports
//             </span>
//           </Link>

//           {/* Desktop Menu */}
//           <div className='hidden md:flex items-center gap-8 text-[#2B2B2B] font-medium'>
//             <Link to='/' className='hover:text-[#F47C20] transition'>
//               Home
//             </Link>

//             <Link to='/products' className='hover:text-[#F47C20] transition'>
//               Products
//             </Link>

//             <Link to='/services' className='hover:text-[#F47C20] transition'>
//               Services
//             </Link>

//             <Link
//               to='/certifications'
//               className='hover:text-[#F47C20] transition'
//             >
//               Certifications
//             </Link>

//             <Link to='/export' className='hover:text-[#F47C20] transition'>
//               Global Export
//             </Link>

//             {/* CTA Button */}
//             <Link
//               to='/contact'
//               className='px-5 py-2 rounded-md text-white font-semibold bg-gradient-to-r from-[#F47C20] to-[#E83E6F] hover:opacity-90 transition shadow-md'
//             >
//               Request Quote
//             </Link>

//             {/* Icons */}
//             <Search className='cursor-pointer hover:text-[#E83E6F]' />
//             <ShoppingCart className='cursor-pointer hover:text-[#E83E6F]' />
//           </div>

//           {/* Mobile Menu Button */}
//           <div className='md:hidden'>
//             <button onClick={() => setIsOpen(!isOpen)}>
//               {isOpen ? <X /> : <Menu />}
//             </button>
//           </div>
//         </div>
//       </div>

//       {/* Mobile Dropdown */}
//       {isOpen && (
//         <div className='md:hidden bg-white shadow-lg px-6 py-6 space-y-4 text-[#2B2B2B] font-medium'>
//           <Link to='/' className='block hover:text-[#F47C20]'>
//             Home
//           </Link>
//           <Link to='/products' className='block hover:text-[#F47C20]'>
//             Products
//           </Link>
//           <Link to='/services' className='block hover:text-[#F47C20]'>
//             Services
//           </Link>
//           <Link to='/certifications' className='block hover:text-[#F47C20]'>
//             Certifications
//           </Link>
//           <Link to='/export' className='block hover:text-[#F47C20]'>
//             Global Export
//           </Link>

//           <Link
//             to='/contact'
//             className='block text-center py-2 rounded-md text-white bg-gradient-to-r from-[#F47C20] to-[#E83E6F]'
//           >
//             Request Quote
//           </Link>
//         </div>
//       )}
//     </nav>
//   )
// }

// export default Navbar








import React, { useEffect, useMemo, useRef, useState } from "react"
import { Menu, X, ShoppingCart, Search, ChevronDown, ArrowUpRight } from "lucide-react"
import { Link, useLocation } from "react-router-dom"
import Logo from "../assets/logo.svg"
import { PRODUCT_CATEGORIES } from "../data/productCategories"

const Navbar: React.FC = () => {
  const [isOpen, setIsOpen] = useState(false)

  // ✅ mega menu
  const [productsOpen, setProductsOpen] = useState(false)
  const [activeCat, setActiveCat] = useState(0)
  const productsBtnRef = useRef<HTMLButtonElement | null>(null)
  const dropdownRef = useRef<HTMLDivElement | null>(null)

  const location = useLocation()

  // close menus on route change
  useEffect(() => {
    setIsOpen(false)
    setProductsOpen(false)
  }, [location.pathname])

  // close on ESC + outside click
  useEffect(() => {
    const onKey = (e: KeyboardEvent) => {
      if (e.key === "Escape") setProductsOpen(false)
    }

    const onClick = (e: MouseEvent) => {
      const t = e.target as Node
      if (
        dropdownRef.current?.contains(t) ||
        productsBtnRef.current?.contains(t)
      ) {
        return
      }
      setProductsOpen(false)
    }

    window.addEventListener("keydown", onKey)
    window.addEventListener("mousedown", onClick)
    return () => {
      window.removeEventListener("keydown", onKey)
      window.removeEventListener("mousedown", onClick)
    }
  }, [])

  const active = useMemo(() => PRODUCT_CATEGORIES[activeCat], [activeCat])

  return (
    <nav className="sticky top-0 z-50 bg-white/90 backdrop-blur border-b border-black/5">
      <div className="max-w-7xl mx-auto px-6">
        <div className="flex items-center justify-between h-20">
          {/* Logo */}
          <Link to="/" className="flex items-center gap-2">
            <div className="w-12 h-12 rounded-full bg-white flex items-center justify-center shadow-sm border border-black/5">
              <img
                src={Logo}
                alt="Amera Exports Logo"
                className="w-12 h-12 object-contain"
                draggable={false}
              />
            </div>

            <span className="text-xl font-bold text-[#C62828]">
              Amera Exports
            </span>
          </Link>

          {/* Desktop Menu */}
          <div className="hidden md:flex items-center gap-8 text-[#2B2B2B] font-medium">
            <Link to="/" className="hover:text-[#F47C20] transition">
              Home
            </Link>

            {/* ✅ Products Mega Dropdown */}
            <div className="relative">
              <button
                ref={productsBtnRef}
                onClick={() => setProductsOpen((v) => !v)}
                className={`relative flex items-center gap-1 transition ${
                  productsOpen ? "text-[#F47C20]" : "hover:text-[#F47C20]"
                }`}
                type="button"
                aria-haspopup="menu"
                aria-expanded={productsOpen}
              >
                Products
                <ChevronDown
                  size={16}
                  className={`transition ${productsOpen ? "rotate-180" : ""}`}
                />
              </button>

              {productsOpen && (
                <>
                  {/* Soft overlay (premium focus) */}
                  <div className="fixed inset-0 z-40 bg-black/20 backdrop-blur-[2px]" />

                  <div
                    ref={dropdownRef}
                    className="absolute z-50 mt-4 w-[860px] max-w-[92vw] rounded-2xl
                               border border-black/10 bg-white/90 backdrop-blur-xl
                               shadow-[0_30px_90px_rgba(0,0,0,0.20)] overflow-hidden"
                    style={{
                      left: "50%",
                      transform: "translateX(-35%)", // pulls menu closer to Products
                    }}
                  >
                    {/* Accent strip */}
                    <div className="h-[3px] w-full bg-gradient-to-r from-[#F47C20] via-[#C9A227] to-[#E83E6F]" />

                    <div className="grid grid-cols-12">
                      {/* LEFT: Categories */}
                      <div className="col-span-4 bg-white/70 border-r border-black/5 p-4">
                        <p className="text-[11px] font-semibold tracking-[0.22em] uppercase text-[#2B2B2B]/60 px-2">
                          Categories
                        </p>

                        {/* Scrollable list */}
                        <div className="mt-3 max-h-[320px] overflow-auto pr-2 space-y-1 custom-scroll">
                          {PRODUCT_CATEGORIES.map((c, idx) => (
                            <button
                              key={c.slug}
                              onMouseEnter={() => setActiveCat(idx)}
                              onFocus={() => setActiveCat(idx)}
                              onClick={() => setActiveCat(idx)}
                              className={`w-full text-left px-3 py-2 rounded-xl transition flex items-center justify-between
                                ${
                                  idx === activeCat
                                    ? "bg-white shadow-sm border border-black/10"
                                    : "hover:bg-black/[0.04]"
                                }`}
                              type="button"
                            >
                              <span className="text-sm font-semibold text-[#101018]">
                                {c.name}
                              </span>
                              <span className="h-2 w-2 rounded-full bg-gradient-to-r from-[#F47C20] to-[#E83E6F] opacity-70" />
                            </button>
                          ))}
                        </div>

                        {/* Mini CTA */}
                        <div className="mt-4 rounded-xl border border-black/10 bg-white p-4">
                          <p className="text-sm font-semibold text-[#101018]">
                            Need custom formulation?
                          </p>
                          <p className="mt-1 text-xs text-[#2B2B2B]/70 leading-relaxed">
                            Share category & requirements — we’ll suggest the best
                            options.
                          </p>
                          <Link
                            to="/contact"
                            onClick={() => setProductsOpen(false)}
                            className="mt-3 inline-flex items-center gap-2 text-sm font-semibold text-[#C62828] hover:text-[#F47C20] transition"
                          >
                            Request Quote <ArrowUpRight size={16} />
                          </Link>
                        </div>
                      </div>

                      {/* RIGHT: Subcategories */}
                      <div className="col-span-8 p-6">
                        <div className="flex items-start justify-between gap-6">
                          <div>
                            <p className="text-[11px] font-semibold tracking-[0.22em] uppercase text-[#2B2B2B]/60">
                              {active.name}
                            </p>
                            <p className="mt-2 text-sm text-[#2B2B2B]/70 max-w-lg leading-relaxed">
                              {active.desc ||
                                "Explore export-ready offerings in this category."}
                            </p>
                          </div>

                          <Link
                            to={`/products/${active.slug}`}
                            onClick={() => setProductsOpen(false)}
                            className="hidden sm:inline-flex items-center gap-2 rounded-lg px-4 py-2 text-sm font-semibold text-white
                                       bg-gradient-to-r from-[#F47C20] to-[#E83E6F] shadow-md shadow-black/10 hover:opacity-95 transition"
                          >
                            View Category <ArrowUpRight size={16} />
                          </Link>
                        </div>

                        <div className="mt-5 grid grid-cols-2 sm:grid-cols-3 gap-3">
                          {active.subcategories.map((s) => (
                            <Link
                              key={s.slug}
                              to={`/products/${active.slug}/${s.slug}`}
                              onClick={() => setProductsOpen(false)}
                              className="group rounded-xl border border-black/10 bg-white px-4 py-3 shadow-sm hover:shadow-md transition"
                            >
                              <p className="text-sm font-semibold text-[#101018] group-hover:text-[#C62828] transition">
                                {s.name}
                              </p>
                              <div className="mt-2 h-[2px] w-10 bg-gradient-to-r from-[#F47C20] to-[#E83E6F] opacity-30 group-hover:opacity-100 transition" />
                            </Link>
                          ))}
                        </div>

                        <div className="mt-6 flex flex-wrap gap-2">
                          {["OEM/ODM", "Private Label", "Export-ready", "GMP Process"].map(
                            (tag) => (
                              <span
                                key={tag}
                                className="rounded-full border border-black/10 bg-black/[0.02] px-3 py-1 text-xs text-[#2B2B2B]/70"
                              >
                                {tag}
                              </span>
                            )
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                </>
              )}
            </div>

            <Link to="/services" className="hover:text-[#F47C20] transition">
              Services
            </Link>

            <Link to="/certifications" className="hover:text-[#F47C20] transition">
              Certifications
            </Link>

            <Link to="/export" className="hover:text-[#F47C20] transition">
              Global Export
            </Link>

            {/* CTA Button */}
            <Link
              to="/contact"
              className="px-5 py-2 rounded-md text-white font-semibold bg-gradient-to-r from-[#F47C20] to-[#E83E6F] hover:opacity-90 transition shadow-md"
            >
              Request Quote
            </Link>

            {/* Icons */}
            <Search className="cursor-pointer hover:text-[#E83E6F]" />
            <ShoppingCart className="cursor-pointer hover:text-[#E83E6F]" />
          </div>

          {/* Mobile Menu Button */}
          <div className="md:hidden">
            <button onClick={() => setIsOpen(!isOpen)}>
              {isOpen ? <X /> : <Menu />}
            </button>
          </div>
        </div>
      </div>

      {/* Mobile Dropdown */}
      {isOpen && (
        <div className="md:hidden bg-white shadow-lg px-6 py-6 space-y-4 text-[#2B2B2B] font-medium">
          <Link to="/" className="block hover:text-[#F47C20]">
            Home
          </Link>

          {/* Mobile Products Accordion */}
          <div className="rounded-xl border border-black/10 overflow-hidden">
            <button
              type="button"
              onClick={() => setProductsOpen((v) => !v)}
              className="w-full flex items-center justify-between px-4 py-3 bg-black/[0.02]"
            >
              <span>Products</span>
              <ChevronDown
                size={16}
                className={`transition ${productsOpen ? "rotate-180" : ""}`}
              />
            </button>

            {productsOpen && (
              <div className="p-3 space-y-2">
                {PRODUCT_CATEGORIES.map((c) => (
                  <div
                    key={c.slug}
                    className="rounded-lg border border-black/10 bg-white"
                  >
                    <Link
                      to={`/products/${c.slug}`}
                      className="block px-4 py-3 font-semibold text-sm"
                      onClick={() => setProductsOpen(false)}
                    >
                      {c.name}
                    </Link>

                    <div className="px-4 pb-3 grid grid-cols-2 gap-2">
                      {c.subcategories.slice(0, 4).map((s) => (
                        <Link
                          key={s.slug}
                          to={`/products/${c.slug}/${s.slug}`}
                          className="text-xs text-[#2B2B2B]/75 hover:text-[#F47C20]"
                          onClick={() => setProductsOpen(false)}
                        >
                          {s.name}
                        </Link>
                      ))}
                    </div>
                  </div>
                ))}
              </div>
            )}
          </div>

          <Link to="/services" className="block hover:text-[#F47C20]">
            Services
          </Link>
          <Link to="/certifications" className="block hover:text-[#F47C20]">
            Certifications
          </Link>
          <Link to="/export" className="block hover:text-[#F47C20]">
            Global Export
          </Link>

          <Link
            to="/contact"
            className="block text-center py-2 rounded-md text-white bg-gradient-to-r from-[#F47C20] to-[#E83E6F]"
          >
            Request Quote
          </Link>
        </div>
      )}
    </nav>
  )
}

export default Navbar















// import React, { useEffect, useMemo, useRef, useState } from "react"
// import { Menu, X, ShoppingCart, Search, ChevronDown, ArrowUpRight } from "lucide-react"
// import { Link, useLocation } from "react-router-dom"
// import Logo from "../assets/logo.svg"
// import { PRODUCT_CATEGORIES } from "../data/productCategories"

// const Navbar: React.FC = () => {
//   const [isOpen, setIsOpen] = useState(false)
//   const [productsOpen, setProductsOpen] = useState(false)
//   const [activeCat, setActiveCat] = useState(0)

//   const dropdownRef = useRef<HTMLDivElement | null>(null)
//   const location = useLocation()

//   // close menus on route change
//   useEffect(() => {
//     setIsOpen(false)
//     setProductsOpen(false)
//   }, [location.pathname])

//   // close dropdown on outside click
//   useEffect(() => {
//     const onClick = (e: MouseEvent) => {
//       if (!dropdownRef.current) return
//       if (!dropdownRef.current.contains(e.target as Node)) setProductsOpen(false)
//     }
//     window.addEventListener("mousedown", onClick)
//     return () => window.removeEventListener("mousedown", onClick)
//   }, [])

//   const active = useMemo(() => PRODUCT_CATEGORIES[activeCat], [activeCat])

//   return (
//     <nav className="sticky top-0 z-50 bg-white/90 backdrop-blur border-b border-black/5">
//       <div className="max-w-7xl mx-auto px-6">
//         <div className="flex items-center justify-between h-20">
//           {/* Logo */}
//           <Link to="/" className="flex items-center gap-2">
//             <div className="w-12 h-12 rounded-full bg-white flex items-center justify-center shadow-sm border border-black/5">
//               <img src={Logo} alt="Amera Exports Logo" className="w-12 h-12 object-contain" draggable={false} />
//             </div>
//             <span className="text-xl font-bold text-[#C62828]">Amera Exports</span>
//           </Link>

//           {/* Desktop Menu */}
//           <div className="hidden md:flex items-center gap-8 text-[#2B2B2B] font-medium">
//             <Link to="/" className="hover:text-[#F47C20] transition">Home</Link>

//             {/* Products Mega */}
//             <div className="relative" ref={dropdownRef}>
//               <button
//                 onClick={() => setProductsOpen((v) => !v)}
//                 className={`flex items-center gap-1 hover:text-[#F47C20] transition ${
//                   productsOpen ? "text-[#F47C20]" : ""
//                 }`}
//                 aria-haspopup="menu"
//                 aria-expanded={productsOpen}
//                 type="button"
//               >
//                 Products <ChevronDown size={16} className={`transition ${productsOpen ? "rotate-180" : ""}`} />
//               </button>

//               {productsOpen && (
//                 <div
//                   className="absolute left-1/2 -translate-x-1/2 mt-4 w-[980px] max-w-[92vw]
//                              rounded-2xl border border-black/10 bg-white shadow-[0_24px_80px_rgba(0,0,0,0.18)]
//                              overflow-hidden"
//                 >
//                   {/* Top accent */}
//                   <div className="h-[3px] w-full bg-gradient-to-r from-[#F47C20] via-[#C9A227] to-[#E83E6F]" />

//                   <div className="grid grid-cols-12">
//                     {/* Left categories */}
//                     <div className="col-span-4 bg-[#fbfbfd] border-r border-black/5 p-4">
//                       <p className="text-xs font-semibold tracking-[0.22em] uppercase text-[#2B2B2B]/60 px-2">
//                         Categories
//                       </p>

//                       <div className="mt-3 space-y-1">
//                         {PRODUCT_CATEGORIES.map((c, idx) => (
//                           <button
//                             key={c.slug}
//                             onMouseEnter={() => setActiveCat(idx)}
//                             onFocus={() => setActiveCat(idx)}
//                             className={`w-full text-left px-3 py-2 rounded-xl transition flex items-center justify-between
//                               ${idx === activeCat ? "bg-white shadow-sm border border-black/5" : "hover:bg-black/[0.03]"}`}
//                             type="button"
//                           >
//                             <span className="text-sm font-semibold text-[#101018]">{c.name}</span>
//                             <span className="h-2 w-2 rounded-full bg-gradient-to-r from-[#F47C20] to-[#E83E6F] opacity-70" />
//                           </button>
//                         ))}
//                       </div>

//                       <div className="mt-4 rounded-xl border border-black/5 bg-white p-4">
//                         <p className="text-sm font-semibold text-[#101018]">Need custom formulation?</p>
//                         <p className="mt-1 text-xs text-[#2B2B2B]/70 leading-relaxed">
//                           Tell us your category & requirements. We’ll share options.
//                         </p>
//                         <Link
//                           to="/contact"
//                           className="mt-3 inline-flex items-center gap-2 text-sm font-semibold text-[#C62828] hover:text-[#F47C20] transition"
//                         >
//                           Request Quote <ArrowUpRight size={16} />
//                         </Link>
//                       </div>
//                     </div>

//                     {/* Right subcategories */}
//                     <div className="col-span-8 p-6">
//                       <div className="flex items-start justify-between gap-6">
//                         <div>
//                           <p className="text-xs font-semibold tracking-[0.22em] uppercase text-[#2B2B2B]/60">
//                             {active.name}
//                           </p>
//                           <p className="mt-2 text-sm text-[#2B2B2B]/70 max-w-lg leading-relaxed">
//                             {active.desc || "Explore our export-ready product offerings in this category."}
//                           </p>
//                         </div>

//                         <Link
//                           to={`/products/${active.slug}`}
//                           className="hidden sm:inline-flex items-center gap-2 rounded-lg px-4 py-2 text-sm font-semibold text-white
//                                      bg-gradient-to-r from-[#F47C20] to-[#E83E6F] shadow-md shadow-black/10 hover:opacity-95 transition"
//                         >
//                           View Category <ArrowUpRight size={16} />
//                         </Link>
//                       </div>

//                       <div className="mt-5 grid grid-cols-2 sm:grid-cols-3 gap-3">
//                         {active.subcategories.map((s) => (
//                           <Link
//                             key={s.slug}
//                             to={`/products/${active.slug}/${s.slug}`}
//                             className="group rounded-xl border border-black/10 bg-white px-4 py-3 shadow-sm hover:shadow-md transition"
//                           >
//                             <p className="text-sm font-semibold text-[#101018] group-hover:text-[#C62828] transition">
//                               {s.name}
//                             </p>
//                             <div className="mt-2 h-[2px] w-10 bg-gradient-to-r from-[#F47C20] to-[#E83E6F] opacity-30 group-hover:opacity-100 transition" />
//                           </Link>
//                         ))}
//                       </div>

//                       <div className="mt-6 flex flex-wrap gap-2">
//                         {["OEM/ODM", "Private Label", "Export-ready", "GMP Process"].map((tag) => (
//                           <span
//                             key={tag}
//                             className="rounded-full border border-black/10 bg-black/[0.02] px-3 py-1 text-xs text-[#2B2B2B]/70"
//                           >
//                             {tag}
//                           </span>
//                         ))}
//                       </div>
//                     </div>
//                   </div>
//                 </div>
//               )}
//             </div>

//             <Link to="/services" className="hover:text-[#F47C20] transition">Services</Link>
//             <Link to="/certifications" className="hover:text-[#F47C20] transition">Certifications</Link>
//             <Link to="/export" className="hover:text-[#F47C20] transition">Global Export</Link>

//             <Link
//               to="/contact"
//               className="px-5 py-2 rounded-md text-white font-semibold bg-gradient-to-r from-[#F47C20] to-[#E83E6F] hover:opacity-90 transition shadow-md"
//             >
//               Request Quote
//             </Link>

//             <Search className="cursor-pointer hover:text-[#E83E6F]" />
//             <ShoppingCart className="cursor-pointer hover:text-[#E83E6F]" />
//           </div>

//           {/* Mobile Menu Button */}
//           <div className="md:hidden">
//             <button onClick={() => setIsOpen(!isOpen)}>{isOpen ? <X /> : <Menu />}</button>
//           </div>
//         </div>
//       </div>

//       {/* Mobile Dropdown */}
//       {isOpen && (
//         <div className="md:hidden bg-white shadow-lg px-6 py-6 space-y-4 text-[#2B2B2B] font-medium">
//           <Link to="/" className="block hover:text-[#F47C20]">Home</Link>

//           {/* Mobile products accordion */}
//           <div className="rounded-xl border border-black/10 overflow-hidden">
//             <button
//               type="button"
//               onClick={() => setProductsOpen((v) => !v)}
//               className="w-full flex items-center justify-between px-4 py-3 bg-black/[0.02]"
//             >
//               <span>Products</span>
//               <ChevronDown size={16} className={`transition ${productsOpen ? "rotate-180" : ""}`} />
//             </button>

//             {productsOpen && (
//               <div className="p-3 space-y-2">
//                 {PRODUCT_CATEGORIES.map((c) => (
//                   <div key={c.slug} className="rounded-lg border border-black/10 bg-white">
//                     <Link to={`/products/${c.slug}`} className="block px-4 py-3 font-semibold text-sm">
//                       {c.name}
//                     </Link>
//                     <div className="px-4 pb-3 grid grid-cols-2 gap-2">
//                       {c.subcategories.slice(0, 4).map((s) => (
//                         <Link
//                           key={s.slug}
//                           to={`/products/${c.slug}/${s.slug}`}
//                           className="text-xs text-[#2B2B2B]/75 hover:text-[#F47C20]"
//                         >
//                           {s.name}
//                         </Link>
//                       ))}
//                     </div>
//                   </div>
//                 ))}
//               </div>
//             )}
//           </div>

//           <Link to="/services" className="block hover:text-[#F47C20]">Services</Link>
//           <Link to="/certifications" className="block hover:text-[#F47C20]">Certifications</Link>
//           <Link to="/export" className="block hover:text-[#F47C20]">Global Export</Link>

//           <Link
//             to="/contact"
//             className="block text-center py-2 rounded-md text-white bg-gradient-to-r from-[#F47C20] to-[#E83E6F]"
//           >
//             Request Quote
//           </Link>
//         </div>
//       )}
//     </nav>
//   )
// }

// export default Navbar